import { ValuationFormValues } from "@/store/valuationFormStore";
import React from "react";
import { useFormContext } from "react-hook-form";

type LocationProps = {
  location: any;
};

const PropetrtyLocation: React.FC<LocationProps> = ({ location }) => {
  return (
    <div className="mt-6 p-4 w-3/5 bg-gray-50 border border-gray-200 rounded-lg shadow-sm">
      <div>
        {" "}
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center justify-center">
          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
              clipRule="evenodd"
            />
          </svg>
          Location
        </h3>
        {(() => {
          const isUganda =
            !!location?.property?.location?.region ||
            location?.property?.location?.country === "UG";

          return (
            <div className="bg-white p-4 rounded-md border border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-5 gap-2 text-sm">
                {isUganda ? (
                  <>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        Region
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property?.location?.region || "Not available"}
                      </div>
                    </div>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        District
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property.district || "Not available"}
                      </div>
                    </div>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        County
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property?.location?.county || "Not available"}
                      </div>
                    </div>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        Subcounty
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property.sector || "Not available"}
                      </div>
                    </div>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        Parish
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property.cell || "Not available"}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        Province
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property.province ||
                          location?.property.city ||
                          "Not available"}
                      </div>
                    </div>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        District
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property.district || "Not available"}
                      </div>
                    </div>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        Sector
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property.sector || "Not available"}
                      </div>
                    </div>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        Cell
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property.cell || "Not available"}
                      </div>
                    </div>
                    <div className="text-center p-2 bg-gray-50 rounded">
                      <div className="font-medium text-gray-600 text-xs uppercase">
                        Village
                      </div>
                      <div className="text-gray-600 font-semibold">
                        {location?.property.village || "Not available"}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })()}
        <div className="items-start  border-t border-gray-200 justify-center gap-6 flex flex-col md:flex-row mt-4">
          <div className="mt-1 w-1/2 pt-3 flex flex-col  space-y-2">
            <h4 className="text-lg font-bold text-gray-600">Address</h4>
            <div>
              <p className="text-sm text-gray-600">
                <span className="font-bold">Address:</span>{" "}
                <span className="text-gray-800">
                  {location?.property.streetAddress || "Not available"}
                </span>
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600">
                <span className="font-bold">Coordinates:</span>{" "}
                <span className="text-gray-800">
                  ({location?.property?.latitude},{" "}
                  {location?.property?.longitude})
                </span>
              </p>
            </div>
          </div>

          <div className="mt-1 w-1/2 pt-3 flex flex-col  space-y-2">
            <h4 className="text-lg font-bold text-gray-600">Dimentions</h4>

      
            <div className="text-sm text-gray-600">
              Plot shape: <span className="font-semibold">Rectangular</span>
            </div>
            <div className="text-sm text-gray-600">
              Zoning:{" "}
              <span className="font-semibold">Rural Residential (R1B)</span>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default PropetrtyLocation;
